export function toggleValue(current: string[], value: string): string[] {
  if (current.includes(value)) {
    return current.filter((entry) => entry !== value);
  }

  return [...current, value];
}
